import { NgModule } from '@angular/core';
import { UbudLoaderModule } from '@ubud/loader';
import { UbudFormModule } from '@ubud/form';
import { CommonModule } from '@angular/common';
import { RegisterPage } from '@lemsar/auth/views/pages/register.page';
import { RegisterContainer } from '@lemsar/auth/views/containers/register.container';
import { RegisterUserForm } from '@lemsar/auth/views/components/register-user.form';
import { RegisterInstitutionForm } from '@lemsar/auth/views/components/register-institution.form';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { RegisterInstitutionGovernmentForm } from '@lemsar/auth/views/components/register-institution-government.form';
import { RegisterInstitutionPrivateForm } from '@lemsar/auth/views/components/register-institution-private.form';
import { RegisterInstitutionCommunityForm } from '@lemsar/auth/views/components/register-institution-community.form';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { UploadModule } from '@progress/kendo-angular-upload';
import { UploaderModule } from '@shared/module/uploader/uploader.module';
import { RouterModule } from '@angular/router';
import { SignOutPage } from '@lemsar/auth/views/pages/sign-out.page';
import { ActivationPage } from '@lemsar/auth/views/pages/activation.page';
import { RegisterTypeComponent } from '@lemsar/auth/views/components/register-type/register-type.component';

const COMPONENTS: any[] = [
    RegisterUserForm,
    RegisterInstitutionForm,
    RegisterInstitutionGovernmentForm,
    RegisterInstitutionPrivateForm,
    RegisterInstitutionCommunityForm,
    RegisterTypeComponent,
];

const CONTAINERS: any[] = [RegisterContainer];

const PAGES: any[] = [RegisterPage, SignOutPage, ActivationPage];

const KENDO_MODULES: any[] = [ButtonsModule, DropDownsModule, InputsModule, DateInputsModule, UploadModule];

@NgModule({
    declarations: [...COMPONENTS, ...CONTAINERS, ...PAGES],
    imports: [CommonModule, UbudLoaderModule, UbudFormModule, ...KENDO_MODULES, RouterModule, UploaderModule],
    exports: [...COMPONENTS, ...CONTAINERS],
})
export class LemsarAuthViewModule {}



// WEBPACK FOOTER //
// ./src/lemsar/auth/views/module.ts